// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();





export const getImageServices = async(imageName:string, typeImage: string) => {
   
    try {
        
        console.log('aliaselgordo ',+imageName+ typeImage)
        return await http.getImages<any>(`/v1/files/${typeImage}/`+imageName); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}


export const getImageServices2 = async(imageName:string) => {
   
    try {
        
        console.log('aliaselgordo ',+imageName)
        return await http.getImages<any>(`/v1/files/company/`+imageName); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getImageServices ',error);

    }
}
